module.exports = __webpack_public_path__ + "img/21.a6828e08.jpg";